import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from '@mui/material';
import { tokens } from '../theme';
import { useTranslation } from '../hooks/useTranslation';

const ModalPendingConsult = ({ open, onWait, onNewConsult }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: '16px',
          backgroundColor: theme.palette.mode === 'dark' ? '#141414' : '#fff',
          backgroundImage: 'none',
        },
      }}
    >
      <DialogTitle
        sx={{
          pb: '8px',
          pt: '20px',
          px: '24px',
          borderBottom: `1px solid ${colors.grey[700]}`,
        }}
      >
        <Typography variant="h5" fontWeight={700} sx={{ color: colors.grey[100] }}>
          {t('consultation.pendingTitle')}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ px: '24px', py: '24px' }}>
        <Typography variant="body1" sx={{ color: colors.grey[300], mb: '24px' }}>
          {t('consultation.pendingMessage')}
        </Typography>
        <Box sx={{ display: 'flex', gap: '12px', mt: '8px' }}>
          <Button variant="outlined" color="secondary" sx={{ flex: 1 }} onClick={onNewConsult}>
            {t('consultation.startNewConsult')}
          </Button>
          <Button variant="contained" color="secondary" sx={{ flex: 1 }} onClick={onWait}>
            {t('consultation.waitForResult')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalPendingConsult;
